(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  class SimpleSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.simple-banner-slideshow__slide');
      this.dots = this.querySelectorAll('.simple-banner-slideshow__dot');
      this.prevBtn = this.querySelector('[data-action="prev"]');
      this.nextBtn = this.querySelector('[data-action="next"]');
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) * 1000 || 5000;
      this.autoplayInterval = null;
      this.isTransitioning = false;
      this.transitionDuration = 500; // ms

      this.init();
    }

    init() {
      // Pré-carregar todas as imagens
      this.preloadImages();

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });

      // Autoplay
      if (this.autoplay) {
        this.startAutoplay();

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    preloadImages() {
      // Pré-carregar todas as imagens dos slides
      this.slides.forEach((slide) => {
        const images = slide.querySelectorAll('img');
        images.forEach((img) => {
          if (img.complete) return;
          // Forçar carregamento
          const preloadImg = new Image();
          preloadImg.src = img.src;
          // Também pré-carregar srcset se existir
          if (img.srcset) {
            const srcsetUrls = img.srcset.split(',').map(s => s.trim().split(' ')[0]);
            srcsetUrls.forEach(url => {
              const preload = new Image();
              preload.src = url;
            });
          }
        });
        // Pré-carregar sources do picture element
        const sources = slide.querySelectorAll('source');
        sources.forEach((source) => {
          if (source.srcset) {
            const srcsetUrls = source.srcset.split(',').map(s => s.trim().split(' ')[0]);
            srcsetUrls.forEach(url => {
              const preload = new Image();
              preload.src = url;
            });
          }
        });
      });
    }

    handleSwipe(startX, endX) {
      const threshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    }

    prev() {
      if (this.isTransitioning) return;
      const newIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(newIndex);
    }

    next() {
      if (this.isTransitioning) return;
      const newIndex = this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
      this.goToSlide(newIndex);
    }

    goToSlide(index) {
      if (this.isTransitioning || index === this.currentIndex) return;

      this.isTransitioning = true;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[index];

      // Preparar o próximo slide (visível mas transparente)
      nextSlide.classList.add('simple-banner-slideshow__slide--next');

      // Forçar reflow para garantir que a transição funcione
      nextSlide.offsetHeight;

      // Iniciar fade out do atual e fade in do próximo
      currentSlide.classList.add('simple-banner-slideshow__slide--fading-out');
      nextSlide.classList.add('simple-banner-slideshow__slide--fading-in');

      // Atualizar dots imediatamente
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('simple-banner-slideshow__dot--active');
      }
      if (this.dots[index]) {
        this.dots[index].classList.add('simple-banner-slideshow__dot--active');
      }

      // Após a transição, limpar classes
      setTimeout(() => {
        currentSlide.classList.remove('simple-banner-slideshow__slide--active', 'simple-banner-slideshow__slide--fading-out');
        nextSlide.classList.remove('simple-banner-slideshow__slide--next', 'simple-banner-slideshow__slide--fading-in');
        nextSlide.classList.add('simple-banner-slideshow__slide--active');

        this.currentIndex = index;
        this.isTransitioning = false;
      }, this.transitionDuration);

      // Reset autoplay timer
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      if (this.autoplayInterval) return;
      this.autoplayInterval = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  if (!customElements.get('simple-slideshow')) {
    customElements.define('simple-slideshow', SimpleSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
